import Vue from 'vue'
import {format} from './utils.js'

//console.log(Vue.version)

Vue.filter('formatDate', function (value,para) {
  if(!value || value == "") {
    return "-"
  }
  var para = para || 'YYYY-MM-DD hh:mm:ss'
  return format(new Date(value),para)
})
Vue.filter('formatTimeline', function (value,para) {
  if(!value || value == "") {
    return "-"
  }
  var points = Math.floor(value % 3600);
  var when = Math.floor(value / 3600)
  var min = Math.floor(points / 60)
  var seconds = value % 60;
  if(when < 10){
    var hh = "0" + when;
  }else{
    var hh = when;
  }
  if(min < 10){
    var mm = "0" + min;
  }else{
    var mm = min;
  }
  if(seconds < 10){
    var ss = "0" + seconds;
  }else{
    var ss = seconds;
  }
  return hh + ":" + mm + ":" + ss
})


Vue.filter('percent', function (value,para) {
  if(value == "-" || (value != 0 &&(!value || value == ""))) {
    return "-"
  }
  var para = para || 2;
  return parseInt(value*10000)/100+"%";
})

Vue.filter('decode',function (s){
  if (typeof s === 'string' && /\\(u[0-9a-fA-F]{4})/.test(s)) {
    return unescape(s.replace(/\\(u[0-9a-fA-F]{4})/gm, '%$1'))
  }
  return s
})

Vue.filter('space',function (s){
  if(!s || s<0) {return "-"}
  if(s < 1024) {
    return s+"KB";
  } else if (s < 1024*1024) {
    return (s/1024).toFixed(2) +"MB"
  } else if (s < 1024*1024*1024) {
    return (s/1024/1024).toFixed(2) + "GB"
  } else if (s < 1024*1024*1024*1024) {
    return (s/1024/1024/1024).toFixed(2) + "TB"
  } else {
    return (s/1024/1024/1024/1024).toFixed(2) + "PB"
  }
});

Vue.filter('duration',function (s){
  if(s < 60) {
    return s+"秒";
  } else if (s < 60*60) {
    return parseInt(s/60) +"分"+s%60 + "秒"
  } else if (s < 60*60*60) {
    seconds = s%(60*60);
    return parseInt(s/60/60) + "小时" + parseInt(seconds/60) + "分" + seconds%60 + "秒"
  }
})

Vue.filter('not',{
  read:function (value) {
    return !value;
  },
  write:function (value) {
    var newValue = !value;
    return newValue;
  }
})
